import React, { useContext } from "react";
import { FaSchool, FaGraduationCap, FaUniversity } from "react-icons/fa";
import { ThemeContext } from "../themeProvider";

const Education = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div
      id="education"
      className={`py-12 px-6 ${!darkMode ? "bg-gray-900 text-white" : "bg-white text-gray-900"
        }`}
    >
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-4xl font-bold mb-12">Education</h2>
        <div
          className={`flex justify-between items-start border-t pt-8 px-4 space-x-4 overflow-x-auto ${!darkMode ? "border-gray-700" : "border-gray-300"
            }`}
        >
          {/* Higher Secondary */}
          <div className="flex flex-col items-center space-y-4">
            <p className="text-sm text-gray-500">2016–2018</p>
            <FaSchool className="text-green-400 text-3xl" />
            <div
              className={`${!darkMode ? "bg-gray-800 text-white" : "bg-gray-100 text-black"
                } rounded-lg p-4 w-64 text-left shadow-md`}
            >
              <h3 className="text-lg font-semibold">
                Higher Secondary Education
              </h3>
              <p className="text-sm text-gray-500">Narayana Junior College, India
                <a
                  href="https://www.narayanajuniorcolleges.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${darkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                >
                  &nbsp; 🔗
                </a>
              </p>
              <p className="text-sm mt-1">Percentage: 87%</p>
            </div>
          </div>

          {/* B.Tech */}
          <div className="flex flex-col items-center space-y-4">
            <p className="text-sm text-gray-500">2018–2022</p>
            <FaGraduationCap className="text-green-400 text-3xl" />
            <div
              className={`${!darkMode ? "bg-gray-800 text-white" : "bg-gray-100 text-black"
                } rounded-lg p-4 w-64 text-left shadow-md`}
            >
              <h3 className="text-lg font-semibold">B.Tech Computer Science</h3>
              <p className="text-sm text-gray-500">CMR College of Engineering & Technology, India
                <a
                  href="https://cmrcet.ac.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${darkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                >
                  &nbsp; 🔗
                </a>
              </p>
              <p className="text-sm mt-1">CGPA: 8.1</p>
            </div>
          </div>

          {/* M.S. */}
          <div className="flex flex-col items-center space-y-4">
            <p className="text-sm text-gray-500">2024–2026 (Expected)</p>
            <FaUniversity className="text-green-400 text-3xl" />
            <div
              className={`${!darkMode ? "bg-gray-800 text-white" : "bg-gray-100 text-black"
                } rounded-lg p-4 w-64 text-left shadow-md`}
            >
              <h3 className="text-lg font-semibold">M.S. Computer Science</h3>
              <p className="text-sm text-gray-500">Oregon State University, USA
                <a
                  href="https://oregonstate.edu/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${darkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                >
                  &nbsp; 🔗
                </a>
              </p>
              <p className="text-sm mt-1">GPA: 3.88</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Education;
